import axios from 'axios'

export const getFinanceNumbers = () => {
  return axios.get('/finance/numbers/format')
}

export const getFinanceNumberFormat = (id, params) => {
  return axios.get(`/finance/numbers/${id}`, { params })
}

export const getFinanceNumberFormatDetail = (id) => {
  return axios.get(`/finance/numbers/${id}/format`)
}

export const editFinanceNumber = (id, data) => {
  return axios.put(`/finance/numbers/${id}`, data)
}

export const getFinanceNumberNext = (name, params, config = {}) => {
  return axios.get(`/finance/numbers/next/${name}`, { params, ...config })
}

export const isFinanceNumberExist = (name, params) => {
  return axios.get(`/finance/numbers/exists/${name}`, { params })
}

export const getFinanceNumberTrans = () => {
  return axios.get('/finance/numbers/trans')
}

export const createFinanceNumberTrans = (data) => {
  return axios.post('/finance/numbers/trans', data)
}

export const editFinanceNumberTrans = (id, data) => {
  return axios.put(`/finance/numbers/trans/${id}`, data)
}

export const deleteFinanceNumberTrans = (id) => {
  return axios.delete(`/finance/numbers/trans/${id}`)
}

export const getFinanceNumberLog = ({ params } = {}) => {
  return axios.get(`/finance/numbers/logs`, { params })
}

export const getFinanceNumberDetailLog = ({ id, params } = {}) => {
  return axios.get(`/finance/numbers/logs/${id}`, { params })
}
